import { render } from "./hotPosition.vue?vue&type=template&id=5508b690&scoped=true"
import script from "./hotPosition.vue?vue&type=script&lang=js"
export * from "./hotPosition.vue?vue&type=script&lang=js"

import "./hotPosition.vue?vue&type=style&index=0&id=5508b690&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5508b690"]])

export default __exports__